<div class="preview-modal" *ngIf="isVisible">
    <div class="preview-content">
      <button class="close-button" (click)="closePreview()">×</button>
      <h3>Vista previa del documento</h3>
      
      <div class="preview-container" [ngSwitch]="fileType">
        <ng-container *ngSwitchCase="'image'">
          <img [src]="previewUrl" alt="Preview" class="image-preview">
        </ng-container>
        
        <ng-container *ngSwitchCase="'pdf'">
          <iframe 
            [src]="previewUrl" 
            class="pdf-preview" 
            type="application/pdf">
          </iframe>
        </ng-container>
        
        <div *ngSwitchDefault class="unsupported-format">
          <i class="fas fa-file-alt"></i>
          <p>Vista previa no disponible para este tipo de archivo</p>
          <small>{{fileName}}</small>
        </div>
      </div>
    </div>
  </div>